module.exports = __webpack_public_path__ + "img/Ellipse_480.86eef7b2.svg";